import Tr from 'translations/Translations';

const createItem = (trKey, value=Tr(trKey)) => ({
	label: Tr(trKey),
	value,
})

export default [
	createItem('procedure_type_s_1', '1'),
	createItem('procedure_type_s_2', '2'),
	createItem('procedure_type_s_3', '3'),
	createItem('procedure_type_s_4', '4'),
	createItem('procedure_type_s_5', '5'),
]





